// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { Button, ButtonRow } from '@op/opds.opux';
import { Modal } from '@op/opds.opux-modal';
import message from '../messages';
import { pageRoutes } from '../Constants';
import { useNavigate } from 'react-router';

interface AdminInfoNoticeModalProps {
    isOpen: boolean;
    closeModal: () => void;
    type: string[];
}

const updateModalState = (state: { open: boolean }, closeModal: any) => {
    if (!state.open) {
        closeModal(false);
    }
};

const AdminInfoNoticeModal: React.FC<AdminInfoNoticeModalProps> = ({ isOpen, closeModal, type }) => {
    const navigate = useNavigate();
    const routeTo = (): void => {
        const path = pageRoutes.infoPreview;
        navigate(path);
    };

    const localizedType: string = type.map((oneType) => message(oneType)).join(', ');

    return (
        <Modal
            isOpen={isOpen}
            className="interruption-modal"
            onUpdate={(state) => updateModalState(state, closeModal)}
            footer={
                <div className="modal-footer" data-testid="adminInfoNoticeModalFooter">
                    <ButtonRow>
                        <Button alternate onClick={() => closeModal()} data-testid="adminInfoNoticeModalCancelButton">
                            {message('no')}
                        </Button>
                        <Button finish onClick={routeTo} data-testid="adminInfoNoticeModalConfirmButton">
                            {message('yes')}
                        </Button>
                    </ButtonRow>
                </div>
            }
            title={message('adminNotificationModalTitle')}
            data-testid="adminInfoNoticeModal"
        >
            <div className="opux-v6__opds" data-testid="adminInfoNoticeModalContent">
                <p data-testid="adminInfoNoticeModalMessage">
                    {message('adminNotificationModalMessage', { localizedType })}
                </p>
                <p data-testid="adminInfoNoticeModalConfirmMessage">
                    {message('confirmContinueAdminNotificationModal')}
                </p>
            </div>
        </Modal>
    );
};

export default AdminInfoNoticeModal;
